<template>
	<div class="text-label-tertiary text-sm font-medium capitalize">
		<slot />
	</div>
</template>
